import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigurationPageDTO } from '../../features/parameters/configuration/configuration-page-dto.model';
import { GenericResponse } from '../models/generic-response.model';

const options = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json; charset=utf-8',
  }),
};
@Injectable({
  providedIn: 'root',
})
export class ConfigurationClientService {
  private apiURL = environment.apiURL;

  constructor(private readonly http: HttpClient) {}

  public getAllConfigurations(): Observable<ConfigurationPageDTO[]> {
    return this.http.get<ConfigurationPageDTO[]>(this.apiURL + '/v2/configuration');
  }

  public getMaintenanceBanner(): Observable<{ enabled: boolean; message: string }> {
    return this.http.get<{ enabled: boolean; message: string }>(this.apiURL + '/v2/maintenance-banner');
  }

  public saveConfigurationParametersDetails(config: ConfigurationPageDTO[]): Observable<GenericResponse> {
    return this.http.post<GenericResponse>(this.apiURL + '/services/configuration/saveConf', { configurationAsJson: JSON.stringify(config) }, options);
  }
}
